"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonDropDownMenu = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var index_1 = require("../index");
require("./buttonDropDownMenu.css");
var ButtonDropDownMenu = function (_a) {
    var label = _a.label, onClick = _a.onClick, open = _a.open, styleType = _a.styleType, className = _a.className;
    return ((0, jsx_runtime_1.jsx)(index_1.Button, __assign({ onClick: onClick, styleType: styleType ? styleType : 'primary', size: "std", stretch: true, customStyle: { lineHeight: '1.8' }, className: "button-drop-down-menu ".concat(open, " ").concat(className), type: "button" }, { children: label })));
};
exports.ButtonDropDownMenu = ButtonDropDownMenu;
//# sourceMappingURL=ButtonDropDownMenu.js.map